import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/comment/listAll',
    method: 'get',
    params: params
  })
}

export function auditComment(params) {
  return request({
    url: '/comment/auditComment',
    method: 'post',
    params: params
  })
}

export function deleteComment(params) {
  return request({
    url: '/comment/delete',
    method: 'post',
    params: params
  })
}

export function replyComment(params) {
  return request({
    url: '/comment/replyComment',
    method: 'post',
    params: params
  })
}

export function commentDetail(params) {
  return request({
    url: '/comment/getCommentInfo',
    method: 'post',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/comment.js